<template>
  <div style="height: 100vh;">
    <div class="top">
      <!-- <img src="../../assets/title4.png" style="width: 40%;height: 80%;" > -->
      高新区知识产权运营服务平台
    </div>
    <div class="font">石家庄高新区知识产权运营保护、创新知识产权服务</div>
    <div class="login-wrap">
      <div class="form">
        <a-form id="components-form-demo-normal-login" :form="form" class="login-form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              size="large"
              v-decorator="[
                'userName',
                { rules: [{ required: true, message: '请输入用户名!' }] },
              ]"
              placeholder="账号">
              <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              size="large"
              v-decorator="[
                'password',
                { rules: [{ required: true, message: '请输入密码!' }] },
              ]"
              type="password"
              placeholder="密码">
              <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-row type="flex" justify="space-between">
              <a-checkbox
                v-decorator="[
                  'remember',
                  {
                    valuePropName: 'checked',
                    initialValue: true,
                  },
                ]">
                记住密码
              </a-checkbox>
            </a-row>
          </a-form-item>

          <a-button
            :loading="load"
            style="margin-top: 20px;margin-bottom: 20px;"
            block
            type="primary"
            html-type="submit"
            class="login-form-button">
            登录
          </a-button>
        </a-form>
      </div>

    </div>
  </div>

</template>

<script>
	import axios from 'axios'
	import md5 from 'js-md5'
	const login = (params) => {
		axios.defaults.withCredentials = true
		return axios.post('http://39.107.241.80:8081/guoweiBrand/login', {
			...params
		})
	}
	export default {
		beforeCreate () {
			this.form = this.$form.createForm(this, {
				name: 'normal_login'
			})
		},
		data () {
			return {
				load: false
			}
		},
		mounted () {
			if (this.$cookies.get('user')) {
				this.form.setFieldsValue({
					userName: this.$cookies.get('user').username,
					password: this.$cookies.get('user').password
				})
			}
		},
		methods: {
			handleSubmit (e) {
				this.load = true
				e.preventDefault()
				this.form.validateFields((err, values) => {
					if (!err) {
						login({
							username: values.userName,
							password: md5(values.password)
							// token:'123'
						}).then(({
							data
						}) => {
							if (data.retCode === '0000') {
								this.$message.success('登录成功', 2, () => {
									this.load = false
									var user = {}
									if (values.remember === true) {
										user.username = values.userName
										user.password = values.password
									} else {
										user.username = ''
										user.password = ''
									}

									localStorage.setItem('local', JSON.stringify(data.data.token))
									this.$cookies.set('user', user)
									this.$router.push('/into')
									this.$store.commit('addUser', values.userName)
								})
							} else {
								this.load = false
								this.$message.error(data.retMsg)
							}
						})
					} else {
						this.load = false
					}
				})
			}
		}

	}
</script>
<style>
	.font {
		line-height: 40px;
		font-weight: 900;
		padding: 30px;
		font-size: 22px;
		color: white;
		position: absolute;
		/* left: 10%; */
		top: 40%;
		z-index: 999;
		border-radius: 5px;
		height: 20vh;
		width: 60vh;
		background-color: #9EA8C1;
		display: flex;
		justify-content: center;
		align-items: center;
		opacity: 0.8
	}

	.form {
		position: absolute;
		left: 75%;
		top: 50%;
		width: 350px;
		margin: -190px 0 0 -175px;
		border-radius: 5px;

		overflow: hidden;
		/* margin: 160px auto; */
		/* 上下间距160px，左右自动居中*/
		background-color: rgb(255, 255, 255, 0.8);
		height: 50vh;
		width: 60vh;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.login-form {
		height: 80%;
		width: 70%;
	}

	.login-wrap {
		position: relative;
		width: 100%;
		height: 92%;
		background-image: url(../../assets/sky.jpg);
		/* background-repeat: no-repeat; */
		background-size: 100%;
	}

	.top {
		/* z-index: 999; */
		/* position: absolute; */

		display: flex;
		font-family: '黑体';
		align-items: center;
		height: 8%;
		font-size: 30px;
		margin-left: 4%;
		/* font-style:italic; */
		/* position: relative; */
		width: 70%;
		color: black;
		letter-spacing: 5px;

		/* background-image: url(../../assets/new.png); */
		/* background-size: 100%; */
	}
</style>
